import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

// The page header's Export button when the page's data failed to load or isn't available
function DisabledExportButton() {
  return (
    <Dropdown drop="down" className="ms-3 p-0">
      <Dropdown.Toggle variant="light" id="dropdownToggleExport" className="ms-0" disabled>
        <FormattedMessage id="GENERAL.EXPORT" />
      </Dropdown.Toggle>
    </Dropdown>
  )
}

DisabledExportButton.propTypes = {}

export default React.memo(DisabledExportButton)
